<template lang="pug">
  .payment-settings
    v-container(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content(v-else)
        v-card.ma-4.mt-2(v-if="Auth('component', '/admin/settings/checkout#pass_service_fee')" flat style="border:1px solid var(--v-basic300);")
          v-card-text.py-0
            v-row(align="center")
              v-col
                .s1.primary500--text {{ $t('pass_service_fee') }}
                .c1.basic600--text {{ $t('pass_service_fee_text') }}
              v-col.shrink
                y-switch.mr-n2.my-auto(v-model="isPassServiceFee" @change="updatePassServiceFee(isPassServiceFee)")
        v-card.ma-4(flat style="border:1px solid var(--v-basic300);")
          .version.pa-4
            .c1.basic600--text {{ $t('you_are_currently_using') }}:
            v-row.pa-0(align='center')
              v-col.py-0
                .s2(:class="version.textColor + '--text'") {{ version.text }}
              v-col.py-0.shrink
                v-chip(small outlined :color="version.buttonColor" :style="{ 'background-color': version.buttonBackgroundColor + '!important' }" )
                  .s2(:class="version.buttonColor + '--text'") {{ version.buttonText }}
                  v-divider.basic300
          //- .revert-to-old(v-if="isNewCheckout)
          //-   .action.pa-4
          //-     v-row.pa-0
          //-       v-col.py-0
          //-         .s1.basic800--text Switch to old checkout
          //-         .c1.basic600--text Go back to the previous multi-page checkout method. This version is no longer maintained.
          //-       v-col.py-0.shrink
          //-         v-chip.button-AA-tiny(label outlined color="black" small height=24  @click="openRevertCheckoutDialog = true") SWITCH BACK
          .update-to-new(v-if="!isNewCheckout")
            .action.pa-4
              .c1.success500--text {{ $t('new') }}!
              v-row.pa-0
                v-col.py-0
                  .s1.basic800--text {{ $t('update_onepage_checkout') }}
                  .c1.basic600--text {{ $t('update_onepage_checkout_text') }}
                  .c1.textColorAccent--text.mt-1.clickable(@click="clickOpenDemoLink()") {{ $t('demo_new_checkout') }}
                v-col.py-0.shrink
                  v-btn(color='textColorAccent' small depressed height=24 @click="openUpdateCheckoutDialog = true")
                    .button-AA-small.basic100--text {{ $t('update') }}
      
      v-card.ma-4(flat style="border:1px solid var(--v-basic300);")
        .conversion.pa-4
          v-row.pa-0
            v-col.py-0
              .s1.basic800--text {{ $t('fb_conversions_api') }}
              .c1.basic600--text {{ $t('fb_conversions_api_text') }}
              .c1.textColorAccent--text.mt-1.clickable(@click="clickLearnMore()") {{ $t('learn_more') }}
            v-col.py-0.shrink
              v-chip.button-AA-tiny(label outlined color="black" small height=24  @click="testingConversionApi = false; openConversionApiDialog = true") {{ $t('manage') }}
      
      v-card.ma-4(flat style="border:1px solid var(--v-basic300);")
        .conversion.pa-4
          .c1.basic800--text {{ $t('let_us_know_checkout') }}
          v-layout.clickable(@click="clickLeaveFeedback()")
            .button-Aa-medium.textColorAccent--text.mr-1.mt-1 {{ $t('leave_feedback') }}
            eva-icon(name="message-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="18" height="18" style="margin-top:1px")
      
      v-card.ma-4(flat style="border:1px solid var(--v-basic300);")
        .thankyou.pa-4
          v-row.pa-0
            v-col.py-0
              .s1.basic800--text {{ $t('thank_you_message') }}
              .c1.basic600--text {{ $t('thank_you_message_text') }}
            v-col.py-0.shrink
              v-btn(color='textColorAccent' small depressed height=24 @click="openEditThankYouDialog = true")
                .button-AA-small.basic100--text {{ $t('edit') }}
      
    .modals
      y-dialog(v-if="tracker" v-model="openConversionApiDialog" persistent max-width="400px")
        v-card
          v-card-title(style="height:56px;")
            .h6.basic800--text {{ $t('fb_conversions_api') }}
          v-divider.basic300
          v-card-text.py-2
            v-form(ref="form")
              .label.basic600--text.text-uppercase.mt-2 FACEBOOK PIXEL ID
              v-text-field.mt-2(solo flat background-color="basic200" height="40" v-model='tracker.fb' outlined dense persistent-hint hide-details="auto" :label="$t('facebook.label')" :placeholder="$t('facebook.placeholder')" :rules="rules.not_empty")
              
              .label.basic600--text.text-uppercase.mt-2 TOKEN
              v-text-field.mt-2(solo flat background-color="basic200" height="40" v-model='tracker.fb_token' outlined dense persistent-hint hide-details="auto" :label="$t('facebook_token.label')" :placeholder="$t('facebook_token.placeholder')" :rules="rules.not_empty")

              .c1.textColorAccent--text.mt-2.clickable(v-if="tracker.fb_token && !testingConversionApi" @click='testingConversionApi = true') {{ $t('send_fb_test_event') }}

              .testing.mt-4(v-if="testingConversionApi")
                .label.basic600--text.text-uppercase.mt-2 {{ $t('test_event_code') }}
                v-text-field.mt-2(solo flat background-color="basic200" height="40" v-model='tracker.fb_test_event_code' outlined dense persistent-hint hide-details="auto" :label="$t('facebook_test_code.label')" :placeholder="$t('facebook_test_code.placeholder')" :rules="rules.not_empty")

                .testing-data.mt-4(v-if="fbTestEventData")
                  .result-ok(v-if="fbTestEventData.status == 'ok'")
                    v-layout
                      eva-icon.mr-2(name="checkmark-circle-2-outline" :fill="$vuetify.theme.themes[$theme].success" width="20" height="20")
                      .c1.primary500--text(style="margin-top:2px") {{ $t('event_id') }}:
                        span.ml-1.font-weight-bold {{ fbTestEventData.event_id }}
                    .c1.basic600--text {{ $t('verify_event_id') }}
                  
                  .result-ko(v-else)
                    v-layout
                      eva-icon.mr-2(name="close-circle-outline" :fill="$vuetify.theme.themes[$theme].danger" width="20" height="20")
                      .c1.danger500--text(style="margin-top:2px") {{ $t('error') }}
                        span.ml-1.font-weight-bold {{ fbTestEventData.event_id }}
                    .c1.basic600--text {{ fbTestEventData.detail }}

          v-card-actions
            v-spacer
            v-btn(color='white', text @click='testingConversionApi ? testingConversionApi = false : openConversionApiDialog = false')
              .button-Aa-small.primary400--text {{ testingConversionApi ? 'Done' : 'Cancel' }}
            v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="saveConversionToken()" :loading="isLoading")
              .button-AA-small.basic100--text {{ testingConversionApi ? 'Send' : 'Save' }}

      y-dialog(v-model="openUpdateCheckoutDialog" persistent max-width="400px")
        v-card
          v-card-title
            div.h6.basic800--text(style="word-break: break-word;") {{ $t('change_checkout_method') }}
          v-card-text.py-2
            .p2.primary400--text {{ $t('change_checkout_method_text_1') }}
            .p2.primary400--text.mt-4 {{ $t('change_checkout_method_text_2') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openUpdateCheckoutDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="updateVersion(true)" :loading="isLoading")
              .button-AA-small.basic100--text {{ $t('confirm') }}
      
      y-dialog(v-model="openRevertCheckoutDialog" persistent scrollable max-width="400px")
        v-card
          v-card-title
            div
              .h6.basic800--text(v-html="$t('switching_back_multipage')")
          v-card-text
            .p2.primary400--text {{ $t('switching_back_multipage_text_1') }}
            .s2.primary500--text.mt-4 {{ $t('switching_back_multipage_text_2') }}
            v-form(ref="form")
              v-radio-group.mt-2(v-model='revertReason' row dense :rules="rules.not_empty")
                v-radio.mb-3(label='Too slow.', value='Too slow.' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('switching_too_slow') }}
                v-radio.mb-3(label='Difficult to learn.', value='Difficult to learn.' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('difficult_to_learn') }}
                v-radio.mb-3(label='Does not suit my business.', value='Does not suit my business.' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('not_suit_business') }}
                v-radio.mb-3(label='Received many customer complaints.', value='Received many customer complaints.' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('many_complaints') }}
                v-radio.mb-3(label='Missing features.', value='Missing features.' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('missing_features') }}
                v-radio.mb-3(label='Other', value='other' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('other') }}
              
              div(v-if="revertReason == 'other'")
                v-textarea.mt-n2(v-model='revertReasonOther' placeholder="Other Reason" outlined dense persistent-hint background-color="basic200" :rules="rules.not_empty" hide-details="auto")

          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openRevertCheckoutDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="updateVersion(false)" :loading="isLoading")
              .button-AA-small.basic100--text {{ $t('submit') }}

      y-dialog(v-if="thankYouMessageData" v-model="openEditThankYouDialog" persistent max-width="400px")
        v-card
          v-card-title(style="height:56px;")
            .h6.basic800--text {{ $t('thankyou.title') }}
          v-divider.basic300
          v-card-text.py-2
            v-form(ref="form")
              div.d-flex.mt-2
                .label.basic600--text.text-uppercase {{ $t('message') }}
                v-spacer
                .c1.basic600--text.text-uppercase(v-if="thankYouMessage") {{ thankYouMessage.length }}/100
                
              v-textarea.mt-2(solo flat background-color="basic200" v-model='thankYouMessage' outlined dense persistent-hint hide-details="auto" :placeholder="$t('thankyou.placeholder')" :maxlength="100")
              
              .label.basic600--text.text-uppercase.mt-4 {{ $t('message_preview.title') }}
              v-card.mt-2(flat style="border:1px solid var(--v-basic300);")
                .thankyou.pa-4.text-center
                  .s1.basic800--text {{ $t('message_preview.text_1') }}
                  .s1.basic600--text.my-2(style="white-space: pre-wrap;")
                    span(v-if="thankYouMessage") {{ thankYouMessage }}
                    span(v-else) {{ $t('message_preview.text_2') }}
                  .p1 {{ $t('message_preview.text_3') }}
                  .p1 {{ $t('message_preview.text_4') }}

                  v-btn.mt-4(color='textColorAccent' small depressed readonly)
                    .button-AA-small.basic100--text {{ $t('message_preview.button') }}

          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openEditThankYouDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="saveThankYouMessage()" :loading="isLoading")
              .button-AA-small.basic100--text {{ $t('save') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CheckoutSettings',
  props: ['company'],
  data () {
    return {
      availableUntil: '12/08/2021',
      isFetching: false,
      isNewCheckout: false,
      isPassServiceFee: false,
      openUpdateCheckoutDialog: false,
      openRevertCheckoutDialog: false,
      openEditThankYouDialog: false,
      thankYouMessage: '',
      thankYouMessageData: null,
      revertReason: null,
      revertReasonOther: '',
      openConversionApiDialog: false,
      testingConversionApi: false,
      tracker: null,
      fbTestEventData: null,
      isLoading: false,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required']
      }
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapState('subscriptions', ['yezzaSubscription']),
    version () {
      if (this.isNewCheckout) {
        return { text: 'One-page checkout', textColor: 'success500', buttonText: 'New', buttonColor: 'success500', buttonBackgroundColor: this.$vuetify.theme.themes[this.$theme].successT08 }
      }
      return { text: 'Multi-page checkout', textColor: 'primary600', buttonText: 'Old version', buttonColor: 'basic600', buttonBackgroundColor: this.$vuetify.theme.themes[this.$theme].basic100T08 }
    }
  },
  mounted () {
    this.fetchInvoiceSettings()
    this.getCompanySettingsList()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchInvoiceSettings() {
      this.isFetching = true
      this.$axios.get(`/companies/${this.company.id}/genes/`)
      .then((resp) => {
        const genes = resp.data.map(gene => gene.feature)
        // console.log(genes)
        this.isNewCheckout = genes.includes('YZ_CHECKOUT_V2')
        this.isPassServiceFee = genes.includes('YZ_PASS_SERVICE_FEE')
        this.isFetching = false
      }).catch(() => {})
      this.$axios.get(`/trackers?company=${this.company.id}`).then((response) => {
        if (response.data.results.length>0) {
          this.tracker = response.data.results[0]
        } else {
          this.tracker = { id: null, fb: null, fb_token: null, fb_test_event_code: null }
        }
      }).catch(() => {})
    },
    getCompanySettingsList () {
      this.$axios.get(`/companies/${this.company.id}/settings/`)
        .then((response) => {
          const thankYouSettingsName = 'yz.checkout.thankyou_message'
          const settingsList = response.data.results
          this.thankYouMessageData = settingsList.find(setting => setting.name === thankYouSettingsName)
          if (!this.thankYouMessageData) {
            this.thankYouMessageData = {
              id: null,
              name: thankYouSettingsName,
              value: '',
              extra_data: {}
            }
          }
          this.thankYouMessage = this.thankYouMessageData.value
        }).catch(() => {})
    },
    saveThankYouMessage () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.thankYouMessageData.value = this.thankYouMessage
      this.isLoading = true
      if (this.thankYouMessageData.id) {
        this.axios.patch(`/companies/${this.company.id}/settings/${this.thankYouMessageData.id}`, this.thankYouMessageData)
          .then((response) => {
            this.thankYouMessageData = response.data
            this.openEditThankYouDialog = false
          })
          .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
        return
      }
      this.axios.post(`/companies/${this.company.id}/settings/`, this.thankYouMessageData)
        .then((response) => {
          this.thankYouMessageData = response.data
          this.openEditThankYouDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveConversionToken () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = {
        company: this.company.id,
        fb: this.tracker.fb,
        fb_token: this.tracker.fb_token
      }
      if (this.testingConversionApi) {
        this.fbTestEventData = null
        params.fb_test_event_code = this.tracker.fb_test_event_code
      }
      if (this.tracker.id) {
        this.axios.put(`/trackers/${this.tracker.id}/`, params)
          .then((response) => {
            this.sendFbTestEvent(response.data)
          })
          .catch(() => {
            this.isLoading = false
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
        return
      }
      this.axios.post(`/trackers/`, params)
        .then((response) => {
          this.tracker = response.data
          this.sendFbTestEvent(response.data)
        })
        .catch(() => {
          this.isLoading = false
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    sendFbTestEvent (tracker) {
      if (!this.testingConversionApi) {
        this.openConversionApiDialog = false
        this.isLoading = false
        return
      }
      this.axios.post(`/trackers/${tracker.id}/send_fb_test_event/`)
        .then((response) => {
          this.fbTestEventData = response.data
          this.isLoading = false
        })
        .catch((e) => {
          if (e.response && e.response.data) {
            this.fbTestEventData = e.response.data
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
          this.isLoading = false
        })
    },
    updatePassServiceFee (state) {
      if (state) {
        this.axios.post(`/companies/${this.company.id}/genes/YZ_PASS_SERVICE_FEE/enable/`)
          .then(() => {
            this.isPassServiceFee = true
          })
          .catch(() => {
            this.isPassServiceFee = false
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
        return
      }
      this.axios.post(`/companies/${this.company.id}/genes/YZ_PASS_SERVICE_FEE/disable/`)
        .then(() => {
          this.isPassServiceFee = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    updateVersion (state) {
      this.isLoading = true
      if (state) {
        this.axios.post(`/companies/${this.company.id}/genes/YZ_CHECKOUT_V2/enable/`)
          .then(() => {
            this.isNewCheckout = true
            this.showMessage(['success', this.$t('success_message.one_page_checkout_updated')])
            this.finishUpdate()
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
        return
      }
      if (!this.$refs.form.validate()) {
        this.isLoading = false
        return
      }
      let params = {
        company: this.company.id,
        type: 'feature-feedback',
        data: {
          feature: 'One-page checkout',
          from: {
            company: this.company.name,
            email: this.member.user.email,
            phone: this.member.phone,
          },
          responses: [
            {
              question: 'Why are you switching back?',
              type: 'text',
              answer: this.revertReason,
              answer_other: this.revertReasonOther
            }
          ]
        }
      }
      this.$axios.post('/requests/', params).catch(() => {})
      this.axios.post(`/companies/${this.company.id}/genes/YZ_CHECKOUT_V2/disable/`)
        .then(() => {
          this.isNewCheckout = false
          this.showMessage(['success', this.$t('success_message.switched_back_old_checkout')])
          this.finishUpdate()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    finishUpdate () {
      this.isLoading = false
      this.openUpdateCheckoutDialog = false
      this.openRevertCheckoutDialog = false
    },
    clickOpenDemoLink () {
      window.open('https://yzza.io/blyj6')
    },
    clickLearnMore () {
      window.open('https://help.yezza.io/hc/en-my/articles/4403348545817')
    },
    clickLeaveFeedback () {
      window.open('https://yezzaio.typeform.com/to/GjWfyRZN')
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "facebook": {
      "label": "Facebook Pixel Id",
      "placeholder": "Example: 1234567890123456"
    },
    "facebook_token": {
      "label": "Facebook Pixel Token",
      "placeholder": "Example: 1234567890123456"
    },
    "facebook_test_code": {
      "label": "Facebook Test event code",
      "placeholder": "Example: TEST1234"
    },
    "thankyou": {
      "title": "Edit Thank You message",
      "placeholder": "Write your Thank You message here."
    },
    "pass_service_fee_text": "Customer will bear the service fees (2.9%)",
    "update_onepage_checkout": "Update to one-page checkout",
    "update_onepage_checkout_text": "Say hello to a faster checkout. Let your customer checkout 2 times faster with the new checkout system.",
    "demo_new_checkout": "View demo for new checkout",
    "fb_conversions_api": "Facebook Conversions API",
    "fb_conversions_api_text": "With the newest privacy updates in iOS 14, please setup “Facebook Conversions API”. The Conversions API will help supplement signals from your Yezza Store.",
    "let_us_know_checkout": "Let us know how this new checkout is doing",
    "thank_you_message_text": "Edit “Thank You” message on order confirmation page",
    "verify_event_id": "You can verify this event in your facebook manager.",
    "change_checkout_method": "You are changing your checkout method.",
    "change_checkout_method_text_1": "Say hello to a faster checkout. Let your customer checkour 2 times faster with the new checkout system.",
    "change_checkout_method_text_2": "With the newest privacy updates in iOS 14, please setup “Facebook Conversions API”. The Conversions API will help supplement signals from your Yezza Store.",
    "switching_back_multipage": "Switching back to multi-page<br>checkout method.",
    "switching_back_multipage_text_1": "This version is no longer maintained",
    "switching_back_multipage_text_2": "Why are you switching back?",
    "not_suit_business": "Does not suit my business.",
    "many_complaints": "Received many customer complaints.",
    "message_preview": {
      "title": "Message preview",
      "text_1": "Thank you for your purchase!",
      "text_2": "“Your custom message will be here”",
      "text_3": "Order #229",
      "text_4": "View and save the full receipt for your reference",
      "button": "View my receipt"
    }
  },
  "id": {
    "facebook": {
      "label": "Id Piksel Facebook",
      "placeholder": "Contoh: 1234567890123456"
    },
    "facebook_token": {
      "label": "Token Piksel Facebook",
      "placeholder": "Contoh: 1234567890123456"
    },
    "facebook_test_code": {
      "label": "Kode acara Uji Facebook",
      "placeholder": "Contoh: TEST1234"
    },
    "terima kasih": {
      "title": "Edit pesan Terima Kasih",
      "placeholder": "Tulis pesan Terima Kasih kamu di sini."
    },
    "pass_service_fee_text": "Pelanggan akan menanggung biaya layanan (2,9%)",
    "update_onepage_checkout": "Perbarui ke pembayaran satu halaman",
    "update_onepage_checkout_text": "Guna pembayaran yang lebih cepat. Biarkan pelanggan kamu melakukan pembayaran 2 kali lebih cepat dengan sistem pembayaran yang baru.",
    "demo_new_checkout": "Lihat demo untuk checkout baru",
    "fb_conversions_api": "API Konversi Facebook",
    "fb_conversions_api_text": "Dengan pembaruan privasi terbaru di iOS 14, siapkan “Facebook Conversions API”. Conversions API akan membantu melengkapi sinyal dari Yezza Store kamu.",
    "let_us_know_checkout": "Beri tahu kami bagaimana kinerja checkout baru ini",
    "thank_you_message_text": "Edit pesan “Terima kasih” pada halaman konfirmasi pesanan",   
    "verify_event_id": "Anda dapat memverifikasi acara ini di pengelola facebook kamu.",
    "change_checkout_method": "Anda sedang mengubah metode pembayaran kamu.",
    "change_checkout_method_text_1": "Sampaikan salam untuk pembayaran yang lebih cepat. Biarkan pelanggan kamu melakukan pembayaran 2 kali lebih cepat dengan sistem pembayaran yang baru.",
    "change_checkout_method_text_2": "Dengan pembaruan privasi terbaru di iOS 14, siapkan “Facebook Conversions API”. Conversions API akan membantu melengkapi sinyal dari Yezza Store kamu.",
    "switching_back_multipage": "Beralih kembali ke metode pembayaran<br>multi-halaman.",
    "switching_back_multipage_text_1": "Versi ini tidak lagi dipertahankan",
    "switching_back_multipage_text_2": "Mengapa kamu beralih kembali?",
    "not_suit_business": "Tidak sesuai dengan bisnis saya.",
    "many_complaints": "Menerima banyak keluhan pelanggan.",
    "message_preview": {
      "title": "Pratinjau pesan",
      "text_1": "Terima kasih atas pembelian kamu!",
      "text_2": "Pesan khusus kamu akan ada di sini",
      "text_3": "Pesan #229",
      "text_4": "Lihat dan simpan tanda terima lengkap untuk referensi kamu",
      "button": "Lihat tanda terima saya"
    }
  }
}
</i18n>